import React from 'react';
import PropTypes from 'prop-types';
import CustomButton from '@components/Button/Button';

export default function UserRemoved({ setUpdateSeatModal }) {
  const handleSupport = () => {
    setUpdateSeatModal(false);
    window?.HubSpotConversations?.widget?.open();
  };
  const handleModalClose = () => {
    setUpdateSeatModal(false);
  };
  return (
    <div className='text-custom-font-color dark:text-white'>
      <div className='font-bold'>We’ve canceled your extra seat(s). </div>
      <div className='text-sm pt-3'>
        Your seat(s) was successfully removed and you won't be charged for it in
        your next billing period. You will no longer be charged on your next
        bill.
      </div>
      <div className='text-sm pt-1'>
        You may contact support if you have questions or continue updating your
        seat(s).
      </div>
      <div className='flex justify-between mt-4 mb-2 gap-5'>
        <div className='w-[50%]'>
          <CustomButton
            style={{ minHeight: '45px' }}
            variant='outlined'
            fullWidth
            onClick={handleSupport}
          >
            Contact Support
          </CustomButton>
        </div>
        <div className='w-[50%]'>
          <CustomButton btnColor='blue' fullWidth onClick={handleModalClose}>
            Update Seat(s)
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

UserRemoved.propTypes = {
  setUpdateSeatModal: PropTypes.func,
};
